/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './payment-paypal-express-checkout.component';
import * as import1 from '@angular/core/src/change_detection/change_detection';
import * as import2 from '@angular/core/src/linker/view_utils';
import * as import3 from '@angular/core/src/linker/view';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/linker/element';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from './cart.service';
import * as import9 from '../shared/utils.service';
import * as import10 from '../shared/config.service';
import * as import11 from '@angular/core/src/metadata/view';
import * as import12 from '@angular/core/src/linker/component_factory';
export class Wrapper_PaymentPayPalExpressCheckoutComponent {
  context:import0.PaymentPayPalExpressCheckoutComponent;
  changed:boolean;
  /*private*/ _expr_0:any;
  constructor(p0:any,p1:any,p2:any) {
    this.changed = false;
    this.context = new import0.PaymentPayPalExpressCheckoutComponent(p0,p1,p2);
    this._expr_0 = import1.UNINITIALIZED;
  }
  check_language(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import2.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this.changed = true;
      this.context.language = currValue;
      this._expr_0 = currValue;
    }
  }
  detectChangesInInputProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import3.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_PaymentPayPalExpressCheckoutComponent_Host:import4.RenderComponentType = (null as any);
class _View_PaymentPayPalExpressCheckoutComponent_Host0 extends import3.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import5.AppElement;
  _PaymentPayPalExpressCheckoutComponent_0_4:Wrapper_PaymentPayPalExpressCheckoutComponent;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_PaymentPayPalExpressCheckoutComponent_Host0,renderType_PaymentPayPalExpressCheckoutComponent_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    this._el_0 = import2.selectOrCreateRenderHostElement(this.renderer,'payment-paypal-express-checkout',import2.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import5.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_PaymentPayPalExpressCheckoutComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._PaymentPayPalExpressCheckoutComponent_0_4 = new Wrapper_PaymentPayPalExpressCheckoutComponent(this.parentInjector.get(import8.CartService),this.parentInjector.get(import9.UtilsService),this.parentInjector.get(import10.ConfigService));
    this._appEl_0.initComponent(this._PaymentPayPalExpressCheckoutComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._PaymentPayPalExpressCheckoutComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.PaymentPayPalExpressCheckoutComponent) && (0 === requestNodeIndex))) { return this._PaymentPayPalExpressCheckoutComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._PaymentPayPalExpressCheckoutComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._PaymentPayPalExpressCheckoutComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_PaymentPayPalExpressCheckoutComponent_Host0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<any> {
  if ((renderType_PaymentPayPalExpressCheckoutComponent_Host === (null as any))) { (renderType_PaymentPayPalExpressCheckoutComponent_Host = viewUtils.createRenderComponentType('',0,import11.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_PaymentPayPalExpressCheckoutComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const PaymentPayPalExpressCheckoutComponentNgFactory:import12.ComponentFactory<import0.PaymentPayPalExpressCheckoutComponent> = new import12.ComponentFactory<import0.PaymentPayPalExpressCheckoutComponent>('payment-paypal-express-checkout',viewFactory_PaymentPayPalExpressCheckoutComponent_Host0,import0.PaymentPayPalExpressCheckoutComponent);
const styles_PaymentPayPalExpressCheckoutComponent:any[] = ([] as any[]);
var renderType_PaymentPayPalExpressCheckoutComponent:import4.RenderComponentType = (null as any);
class _View_PaymentPayPalExpressCheckoutComponent0 extends import3.AppView<import0.PaymentPayPalExpressCheckoutComponent> {
  _el_0:any;
  constructor(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement) {
    super(_View_PaymentPayPalExpressCheckoutComponent0,renderType_PaymentPayPalExpressCheckoutComponent,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import1.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import5.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._el_0 = import2.createRenderElement(this.renderer,parentRenderNode,'div',new import2.InlineArray4(4,'class','text-right','id','paypal-button-container'),(null as any));
    this.init(([] as any[]),[this._el_0],([] as any[]),([] as any[]));
    return (null as any);
  }
}
export function viewFactory_PaymentPayPalExpressCheckoutComponent0(viewUtils:import2.ViewUtils,parentInjector:import6.Injector,declarationEl:import5.AppElement):import3.AppView<import0.PaymentPayPalExpressCheckoutComponent> {
  if ((renderType_PaymentPayPalExpressCheckoutComponent === (null as any))) { (renderType_PaymentPayPalExpressCheckoutComponent = viewUtils.createRenderComponentType('',0,import11.ViewEncapsulation.None,styles_PaymentPayPalExpressCheckoutComponent,{})); }
  return new _View_PaymentPayPalExpressCheckoutComponent0(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/payment-paypal-express-checkout.component.ngfactory.ts